// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Scrollbar } from "swiper";
import { testimonial1 } from "../../../data/testimonialData";

const Testimonial = () => {
  return (
    <>
      <Swiper
        scrollbar={{
          el: ".js-scrollbar",
          draggable: true,
        }}
        modules={[Scrollbar]}
      >
        {testimonial1.map((item) => (
          <SwiperSlide key={item.id}>
            <div className="row items-center x-gap-30 y-gap-20">
              {/*<div className="col-auto">*/}
              {/*  <img src={item.avatar} alt="image" />*/}
              {/*</div>*/}
              <div className="col-auto">
                {/* h3, not h5 - this section only has an h2 (TestimonialRating, rendered
                    alongside this component) above it, so h5 would skip two levels. */}
                <h3 className="text-16 text-white fw-500">{item.name}</h3>
                <div className="text-15 text-white lh-15">
                  {item.designation}
                </div>
              </div>
            </div>
            <p className="text-18 fw-400 text-white mt-30 sm:mt-20">
              {item.text}
            </p>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* start scroll pagination */}
      <div className="d-flex items-center mt-60 sm:mt-20 js-testimonials-slider-pag">
        <div className="text-white fw-500 js-current">01</div>
        <div className="slider-scrollbar -light bg-white-10 ml-20 mr-20 w-max-300  js-scrollbar" />
        <div className="text-white fw-500 js-all">03</div>
      </div>
      {/* end scroll pagination */}
    </>
  );
};

export default Testimonial;
